import Head from 'next/head';

import { useFeature } from '@atc/features';

export default function CreditAppScriptLoader() {

    const [enableCreditApp, { env: drsEnv }] = useFeature('digital_retailing_suite');

    return enableCreditApp && (
        <Head>
            <script // eslint-disable-line @next/next/no-sync-scripts
                src={drsEnv}
                type="text/javascript"
                widget="embed" // eslint-disable-line react/no-unknown-property
                heightPolicy="dynamic" // eslint-disable-line react/no-unknown-property
            />
        </Head>
    );
}
